import { Recurso, UseCaseRecursoAsync } from "lib.common/dist/CleanArch";
import { Pago, PagoDetalle } from "../entities/Pago";
import { GetSomeAbonosPasarelaParams } from "../../utils/params/GetSomeAbonosPasarelaParams";
import { AbonosPasarelaRepository } from "../repositories/AbonosPasarelaRepository";
import { ErrDevGenerico } from "lib.common/dist/errorHandler";

export class GetSomeAbonosPasarelaUseCase<
    T_OUT extends Pago,
    T_OUT2 extends PagoDetalle
> extends UseCaseRecursoAsync<
    GetSomeAbonosPasarelaParams,
    T_OUT[]
> {
    private repository: AbonosPasarelaRepository<T_OUT,T_OUT2>;
    constructor (repository: AbonosPasarelaRepository<T_OUT,T_OUT2>) {
        super();
        this.repository = repository;
    }

    async call(input: GetSomeAbonosPasarelaParams): Promise<Recurso<T_OUT[]>> {
        try {
            return this.repository.getSomeAbonosPasarela(input);
        } catch(error) {
            const errorCapa = new ErrDevGenerico(error as Error);
            return Recurso.fromError<T_OUT[]>(errorCapa);
        }
    }
}